// controllers/useQuestionGameSummaryController.jsx
import { useState } from 'react';
import itemList from '@data/itemMap.json';

const itemMap = Object.fromEntries(itemList.map(item => [String(item.id), item.name]));

export  function UseQuestionGameSummaryController(questions) {
    const [expandedPerPlayer, setExpandedPerPlayer] = useState({});

    const getRankedPlayers = (players) => {
        const sorted = [...players].sort((a, b) => b.score - a.score);
        const ranks = [];
        let currentRank = 1;
        for (let i = 0; i < sorted.length; i++) {
            if (i > 0 && sorted[i].score < sorted[i - 1].score) {
                currentRank = i + 1;
            }
            ranks.push({ ...sorted[i], rank: currentRank });
        }
        return ranks;
    };

    const getMedalClass = (rank) => {
        switch (rank) {
            case 1: return 'winner-gold';
            case 2: return 'winner-silver';
            case 3: return 'winner-bronze';
            default: return '';
        }
    };

    const toggleQuestion = (playerId, questionIndex) => {
        setExpandedPerPlayer(prev => ({
            ...prev,
            [playerId]: {
                ...prev[playerId],
                [questionIndex]: !prev[playerId]?.[questionIndex]
            }
        }));
    };

    const renderQuestion = (index, ItemIcon, renderItemOrText) => {
        const raw = questions[index]?.question;

        const buildMatch = raw.match(/Welche Komponenten benötigt man für den Bau von (\d+)\?/);
        if (buildMatch) {
            const id = buildMatch[1];
            const name = itemMap[id] || id;
            return (
                <h2>
                    Welche Komponenten benötigt man für den Bau von <strong>{name}</strong> <ItemIcon id={id} />?
                </h2>
            );
        }

        const costMatch = raw.match(/Wie viel Gold kostet (\d+) insgesamt\?/);
        if (costMatch) {
            const id = costMatch[1];
            const name = itemMap[id] || id;
            return (
                <h2>
                    Wie viel Gold kostet <strong>{name}</strong> <ItemIcon id={id} /> insgesamt?
                </h2>
            );
        }

        return <h2>{raw}</h2>;
    };

    return {
        expandedPerPlayer,
        getRankedPlayers,
        getMedalClass,
        toggleQuestion,
        renderQuestion
    };
}
